import React from 'react';
import { ThemeProvider, Screen, Card, Button } from '@alterrego/core-ui';
import { AuthProvider, useAuth } from '@alterrego/core-auth';
import tenantConfig from '../tenant.config.json';
import type { TenantConfig, StageId } from '@alterrego/core-config';

// import { PaymentScreen } from '@alterrego/module-payment';
// import { VcardScreen } from '@alterrego/module-vcard';
// import { LoyaltyScreen } from '@alterrego/module-loyalty';

// Résolution du stage au runtime via variables d'env Vite
const STAGE = (import.meta.env.VITE_ALTERREGO_STAGE ?? 'mockup') as StageId;
const DATA_SOURCE = import.meta.env.VITE_ALTERREGO_DATA_SOURCE ?? 'mock';
const ENV = import.meta.env.VITE_ALTERREGO_ENV ?? 'mock';

const config = tenantConfig as TenantConfig;
const stageConfig = config.stages[STAGE];
const authDisabled = stageConfig.auth.includes('disabled');

function AuthenticatedApp() {
  const { status, user, signIn, signOut } = useAuth();

  return (
    <Screen title={config.name}>
      <div style={{ marginBottom: 24, opacity: 0.7, fontSize: 14 }}>
        Stage : <strong>{STAGE}</strong> · Data : <strong>{DATA_SOURCE}</strong> · Env : <strong>{ENV}</strong>
        {user && <> · <strong>{user.email ?? user.displayName}</strong></>}
      </div>
      <div style={{ display: 'grid', gap: 16 }}>
        <Card><h3 style={{ margin: 0 }}>Paiement</h3><p style={{ margin: '8px 0 0', opacity: 0.7 }}>Paiements sans contact et en ligne</p></Card>
        <Card><h3 style={{ margin: 0 }}>Ma carte</h3><p style={{ margin: '8px 0 0', opacity: 0.7 }}>Votre carte de membre et de fidélité</p></Card>
        <Card><h3 style={{ margin: 0 }}>Fidélité</h3><p style={{ margin: '8px 0 0', opacity: 0.7 }}>Cagnotte et récompenses</p></Card>
      </div>
      {status === 'unauthenticated' && (
        <div style={{ marginTop: 32 }}>
          <Button variant="primary" onClick={() => signIn(stageConfig.auth[0] as any)}>
            Se connecter ({stageConfig.auth[0]})
          </Button>
        </div>
      )}
      {status === 'authenticated' && (
        <div style={{ marginTop: 32 }}>
          <Button variant="secondary" onClick={signOut}>Se déconnecter</Button>
        </div>
      )}
    </Screen>
  );
}

export default function App() {
  return (
    <ThemeProvider config={config}>
      {authDisabled ? (
        <MockupApp />
      ) : (
        <AuthProvider config={config} stage={STAGE}>
          <AuthenticatedApp />
        </AuthProvider>
      )}
    </ThemeProvider>
  );
}

function MockupApp() {
  return (
    <Screen title={config.name}>
      <div style={{ marginBottom: 24, opacity: 0.7, fontSize: 14 }}>
        Stage : <strong>{STAGE}</strong> · Data : <strong>{DATA_SOURCE}</strong> · Env : <strong>{ENV}</strong>
      </div>
      <div style={{ display: 'grid', gap: 16 }}>
        <Card><h3 style={{ margin: 0 }}>Paiement</h3><p style={{ margin: '8px 0 0', opacity: 0.7 }}>Paiements sans contact et en ligne</p></Card>
        <Card><h3 style={{ margin: 0 }}>Ma carte</h3><p style={{ margin: '8px 0 0', opacity: 0.7 }}>Votre carte de membre et de fidélité</p></Card>
        <Card><h3 style={{ margin: 0 }}>Fidélité</h3><p style={{ margin: '8px 0 0', opacity: 0.7 }}>Cagnotte et récompenses</p></Card>
      </div>
    </Screen>
  );
}
